import { useConfigStore } from "@/store";
import { useTranslation as useI18nextTranslation } from "react-i18next";
import { useEffect } from "react";
import i18n from "./config";

/**
 * Hook for accessing translations based on the configured language
 * The language is taken from config.translation.language
 * Wraps react-i18next's useTranslation hook
 */
export const useTranslation = () => {
  const { config } = useConfigStore();
  const { t } = useI18nextTranslation();

  const language = config?.translation?.language || "en_US";

  // Change language when config changes
  useEffect(() => {
    if (language && i18n.language !== language) {
      i18n.changeLanguage(language);
    }
  }, [language]);

  return { t, language };
};
